// extracted by mini-css-extract-plugin
export default {"formEl":"form-element_formEl__MDW-G"};